import { combineReducers } from "redux";
import { AuthReducer } from "./AuthReducer"
import { TestListReducer } from "./TestListReducer";
import { TestReducer } from "./TestReducer";

const reducers = combineReducers({

    // here we have to pass all the reducers
    AuthReducer,
    TestListReducer,
    TestReducer
})

// exporting combined reducers 
export default reducers;